var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 3V6H3C2.58398 6 2.25 6.33398 2.25 6.75V9.75C2.25 10.166 2.58398 10.5 3 10.5H3.75V21H5.25V10.5H6C6.41602 10.5 6.75 10.166 6.75 9.75V6.75C6.75 6.33398 6.41602 6 6 6H5.25V3H3.75ZM11.25 3V15H10.5C10.084 15 9.75 15.334 9.75 15.75V18.75C9.75 19.166 10.084 19.5 10.5 19.5H11.25V21H12.75V19.5H13.5C13.916 19.5 14.25 19.166 14.25 18.75V15.75C14.25 15.334 13.916 15 13.5 15H12.75V3H11.25ZM18.75 3V9H18C17.584 9 17.25 9.33398 17.25 9.75V12.75C17.25 13.166 17.584 13.5 18 13.5H18.75V21H20.25V13.5H21C21.416 13.5 21.75 13.166 21.75 12.75V9.75C21.75 9.33398 21.416 9 21 9H20.25V3H18.75ZM3.75 7.5H5.25V9H3.75V7.5ZM18.75 10.5H20.25V12H18.75V10.5ZM11.25 16.5H12.75V18H11.25V16.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSettings);
export default __webpack_public_path__ + "static/media/icon-settings.9ece73952b1a0c508035423e34a44fe2.svg";
export { ForwardRef as ReactComponent };